import { FunctionalComponent, h, ComponentInterface } from '@stencil/core';
import { transformTagNames } from '../../../../global/transform-tag-name';
import { WorkbenchTheme } from '../../../../shared/themes';

interface ChipListRowProps {
  selectedListItems: Array<HTMLWbComboboxListItemElement>;
  theme: WorkbenchTheme;
  noItemsSelectedText: NoItemsSelectedRowProps['noItemsSelectedText'];
  removeItemFromChipList: (item: HTMLWbComboboxListItemElement) => void;
}

interface NoItemsSelectedRowProps {
  noItemsSelectedText: string;
}

const ChipList =
  (that: ComponentInterface) =>
  ({ selectedListItems, noItemsSelectedText, removeItemFromChipList }): FunctionalComponent<ChipListRowProps> => {
    const { WbInteractiveTag, WbText } = transformTagNames(that, 'wb-combobox-list', ['wb-text', 'wb-interactive-tag']);

    return (
      <div class="chip-list-wrapper">
        {selectedListItems.length ? (
          <div class="selected-items-list">
            {selectedListItems.map((item: HTMLWbComboboxListItemElement) => {
              return (
                // eslint-disable-next-line react/jsx-no-bind
                <WbInteractiveTag key={item} variant="button" onWbremove={() => removeItemFromChipList(item)}>
                  {item.innerText}
                </WbInteractiveTag>
              );
            })}
          </div>
        ) : (
          <WbText size="m" tag="span" class="no-selection">
            {noItemsSelectedText}
          </WbText>
        )}
      </div>
    );
  };

export { ChipList as bindChipList };
